import { Box, Card, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 580,
    borderRadius: 8,
    boxShadow: "0px 10px 0px -7px rgba(0,0,0,0)",
  },
  firstBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  textHeaderStyle: {
    marginLeft: "2ch",
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.blue,
    margin: "auto 0",
  },
  textTotalNameStyle: {
    fontSize: "15px",
    fontWeight: "normal",
    color: theme.darkGray2,
  },
  textTotalAmountStyle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.darkGray,
  },
  positiveTextTotalPercent: {
    fontSize: "14px",
    fontWeight: "normal",
    color: theme.green,
  },
  negativeTextTotalPercent: {
    fontSize: "14px",
    fontWeight: "normal",
    color: theme.red,
  },
  insideCardContainer: {
    width: 144,
    height: 70,
    // border: "1px solid #F4F4F4",
    borderRadius: 12,
    display: "grid",
  },
  textBoxInsideCardcontainer: {
    margin: "auto 20px",
  },
}));
function CardChart({ data, chart }) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Box className={classes.firstBox}>
        <Typography className={classes.textHeaderStyle}>{data.name}</Typography>
        <Box classes={{ root: classes.insideCardContainer }}>
          <Box className={classes.textBoxInsideCardcontainer}>
            <Typography className={classes.textTotalNameStyle}>
              {data.totalName}
            </Typography>
            <Typography className={classes.textTotalAmountStyle}>
              {isNaN(data.totalAmount)
                ? "0"
                : data.totalAmount?.toLocaleString()}
            </Typography>
            {/* <Typography className={classes.positiveTextTotalPercent}>
              {data.totalPercent.toFixed(2)}%
            </Typography> */}
          </Box>
        </Box>
      </Box>
      {chart}
    </Card>
  );
}

export default CardChart;
